import React, { useState } from "react";
import { Link } from "react-router-dom";
import Spinner from "Components/RequestHandler/Spinner";

const Courses = ({ data, loading }) => {
  // State to track the number of courses displayed
  const [displayedCourses, setDisplayedCourses] = useState(2);

  // Function to handle Load More/Collapse
  const handleToggleCourses = () => {
    if (displayedCourses >= data?.length) {
      setDisplayedCourses(2); // Collapse to show only two courses
    } else {
      setDisplayedCourses(displayedCourses + 2); // Load more courses
    }
  };

  return (
    <section>
      <h2 className="text-3xl font-bold text-white uppercase mb-4">
        Upcoming Training
      </h2>
      <div className="overflow-x-scroll xxl:overflow-hidden">
        <table className="min-w-full text-white">
          <thead className="bg-[#333] uppercase min-w-[max-content]">
            <tr className="grid grid-cols-3 text-xl min-w-[max-content]">
              <th className="text-left p-4 col-span-2 font-semibold text-lsg">
                Course Title
              </th>
              <th className="text-left p-4 col-span-1 font-semibold text-lsg min-w-[max-content]">
                | Start - End Date
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <div className="mt-4">
                <Spinner />
                <p className="text-white capitalize">loading courses...</p>
              </div>
            ) : (
              data?.slice(0, displayedCourses).map((course, index) => (
                <tr
                  key={index}
                  className="grid grid-cols-3 text-2xl border-b border-gray-700"
                >
                  <td className="col-span-2 p-4 min-w-[max-content]">
                    <Link
                      to={`/academy/upcoming_courses/${course.slug}`}
                      className="hover:underline"
                    >
                      {course.course_title}
                    </Link>
                  </td>
                  <td className="col-span-1 p-4 min-w-[max-content]">
                    | {course.start_date} till {course.end_date}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        {/* <button
          onClick={handleToggleCourses}
          className="mt-6 py-3 bg-[#222] w-full text-font uppercase font-semibold rounded"
        >
          {displayedCourses >= data?.length ? "Collapse" : "Load More"}
        </button> */}
      </div>
    </section>
  );
};

export default Courses;
